export enum DISABLE_AUTHENTICATION_STEPS {
    Confirmation,
    SendOtpCode,
    SendEmailCode
}
